/** Skip debounced cloud push while applying a remote save locally. */
let applyingRemoteSave = false;

export function isApplyingRemotePlayerSave(): boolean {
  return applyingRemoteSave;
}

export async function runApplyingRemotePlayerSave<T>(fn: () => Promise<T>): Promise<T> {
  applyingRemoteSave = true;
  try {
    return await fn();
  } finally {
    applyingRemoteSave = false;
  }
}
